import { buildValidator } from "./buildValidator";

export const address = buildValidator("invalid", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");
  if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
    return true;
  }
  return !!value;
});
